import { useState } from "react";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function AIClientInsight({ clientId }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const run = async () => {
    if (!clientId) return;
    setLoading(true);
    setText("");
    try {
      const { data } = await api.get(`/ai/clients/${clientId}/insight`);
      setText(data.insight);
    } catch (e) {
      setText("Could not generate insight. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (!clientId) {
    return (
      <div className="p-4 text-xs text-zinc-500 font-mono border border-dashed border-zinc-300">
        [ Save the client first to use AI insights ]
      </div>
    );
  }

  return (
    <div className="bg-[#EFF4FF] border border-[#002FA7] p-4" data-testid="ai-client-insight">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles size={14} className="text-[#002FA7]" />
        <p className="label-caps text-[#002FA7]">AI client insight</p>
      </div>
      {text ? (
        <pre className="text-sm whitespace-pre-wrap font-sans text-zinc-800 leading-relaxed max-h-72 overflow-y-auto scrollbar-thin">{text}</pre>
      ) : (
        <p className="text-xs text-zinc-600">
          Generate AI summary: compliance risk, revenue opportunity, collection priority, and suggested next action.
        </p>
      )}
      <button
        onClick={run}
        disabled={loading}
        data-testid="generate-client-insight"
        className="mt-3 bg-[#002FA7] text-white px-3 py-1.5 text-xs font-semibold flex items-center gap-2 hover:bg-blue-800 disabled:opacity-60"
      >
        {loading ? (
          <>
            <span className="font-mono">
              <span className="ai-loading-dot">.</span><span className="ai-loading-dot">.</span><span className="ai-loading-dot">.</span>
            </span>
            Analysing
          </>
        ) : (
          <><Sparkles size={12} /> {text ? "Regenerate" : "Generate"} insight</>
        )}
      </button>
    </div>
  );
}
